"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    type: {
        primary: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
        code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
    },
    weight: {
        regular: '400',
        medium: '500',
        bold: '700',
        extrabold: '900'
    },
    size: {
        s1: 12,
        s2: 14,
        s3: 16,
        s4: 18,
        m1: 20,
        m2: 24,
        m3: 28,
        l1: 32,
        l2: 40,
        l3: 48,
        code: 90
    }
};
//# sourceMappingURL=typography.js.map